export const MIGRATED_ROUTES = [
    '/dashboard',
    '/login',
    '/forgot_password',
    '/reset_password/:token',
    '/auth0_callback'
];
export const shouldUseRR7 = (pathname) => {
    return MIGRATED_ROUTES.some(route => pathname.startsWith(route));
};
